module.exports = __webpack_public_path__ + "img/vertical-line.642203d7.svg";